const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Parses the leading YYYY-MM-DD off any date/datetime string the API returns
// (the server always sends plain strings, never Date objects — see
// config/db.js's dateStrings:true) without going through `new Date()`, which
// would reinterpret the string in the browser's local timezone and can shift
// date-only values by a day.
function parseDateParts(value) {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  return { y: Number(match[1]), m: Number(match[2]), d: Number(match[3]) };
}

// Display format for dates: "17 Aug 2026".
export function formatDate(value) {
  const parts = parseDateParts(value);
  if (!parts) return '—';
  return `${String(parts.d).padStart(2, '0')} ${MONTHS[parts.m - 1]} ${parts.y}`;
}

// Display format for timestamps that also carry a time: "17 Aug 2026, 14:20".
export function formatDateTime(value) {
  const datePart = formatDate(value);
  if (datePart === '—') return '—';
  const timeMatch = String(value).match(/(\d{2}):(\d{2})/);
  return timeMatch ? `${datePart}, ${timeMatch[1]}:${timeMatch[2]}` : datePart;
}

// YYYY-MM-DD for <input type="date"> values — never render this to a user.
export function toInputDate(value) {
  const parts = parseDateParts(value);
  if (!parts) return '';
  return `${parts.y}-${String(parts.m).padStart(2, '0')}-${String(parts.d).padStart(2, '0')}`;
}

// Today's date in Singapore time as YYYY-MM-DD, for comparing against the
// plain date strings the API returns (soc_date/eoc_date etc).
export function todaySGT() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Singapore' }).format(new Date());
}
